"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgoliaAnalyticsDataSource = void 0;
var AlgoliaAnalyticsDataSource;
(function (AlgoliaAnalyticsDataSource) {
    AlgoliaAnalyticsDataSource["PRODUCT_LIST"] = "ProductList";
    AlgoliaAnalyticsDataSource["WISHLIST"] = "Wishlist";
})(AlgoliaAnalyticsDataSource = exports.AlgoliaAnalyticsDataSource || (exports.AlgoliaAnalyticsDataSource = {}));
//# sourceMappingURL=algolia-analytics-data-source.js.map